import {
  computed,
  defineComponent,
  PropType,
} from 'vue';
import { CombiProduct } from '~mall/model/apis/ticketApis';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'CombiSellBar',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<CombiProduct>,
      required: true,
    },
  },
  emits: ['input'],
  setup: (props, { emit }) => {
    const checked = computed({
      get: () => props.value,
      set: (value) => emit('input', value),
    });
    /** 加价购商品是否免费赠送 */
    const isFree = computed(() => !props.data.salePrice);

    if (isFree.value) {
      // * 免费赠送商品直接选中
      checked.value = true;
    }

    const handleCombiCheck = () => {
      if (isFree.value) {
        // * 免费赠送商品不可反选
        return;
      }

      checked.value = !checked.value;
    };

    return () => {
      const {
        goodsName,
        salePrice,
        originalPrice,
      } = props.data;
      const free = isFree.value;
      return (
        <div class={free ? cx('combi') : cx('combi', 'combi-unfree')} onClick={handleCombiCheck}>
          <div class={cx('combi__desc')}>
            {free && <div class={cx('combi__label')}>免费加赠</div>}
            <div class={cx('combi__title')}>{goodsName}</div>
          </div>
          {free
            ? (
            <div class={cx('combi__price-free')}>
              <span>价值</span>
              <span class={cx('combi__price-value')}>{originalPrice}</span>
              <span>元</span>
            </div>
            ) : (
              <div>
                <div class={cx('combi__price-unfree')}>
                  <div class={cx('combi__price-cur')}>{salePrice}<span class={cx('combi__price-cur-unit')}>元</span></div>
                  <div class={cx('combi__price-origin')}>{originalPrice}元</div>
                </div>
                <div
                  class={cx('combi__check', { combi__check_active: checked.value })}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleCombiCheck();
                  }}
                />
              </div>
            )
              }
        </div>
      );
    };
  },
});
